import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './about.css'

const About = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true
        });
    }, []);

    return (
        <div className='aboutUsContainer'>
            <h1 className='aboutUsHeader' data-aos="fade-up">About TailTrace</h1>
            <p className='aboutUsH3' data-aos="fade-up" data-aos-delay="100">
                Every year, millions of pets go missing and too many never make it home. TailTrace was built to change that.
                <br /><br />
                We combine AI powered photo scanning with geolocation technology to create the fastest path from "lost" to "found." When you upload a photo of a missing pet, our system analyzes it for unique identifiers breed characteristics, coat patterns, markings, and more then continuously compares it against every found pet report in your area.
                <br /><br />
                But TailTrace isn't just an algorithm. It's a community. Pet owners, walkers, neighbors, and animal lovers all contribute sightings and reports that power our network. With real time alerts, interactive maps, and scan comparison tools, we give you everything you need to take action the moment it matters.
                <br /><br />
                Whether your pet has slipped out the door or you've spotted a stray in your neighborhood, TailTrace puts the power of reunion in your hands. Because every pet deserves to find their way home.
            </p>
        </div>
    );
}

export default About;